import {
  PATCH_QUOTE,
  PATCH_QUOTE_CLEAR_DATA,
  PATCH_QUOTE_ERROR,
  PATCH_QUOTE_SUCCESS,
  UPDATE_QUOTE,
  UPDATE_QUOTE_CLEAR_DATA,
  UPDATE_QUOTE_ERROR,
  UPDATE_QUOTE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorUpdateQuote: null,
  responseUpdateQuote: null,
  loadingUpdateQuote: false,
  errorPatchQuote: null,
  responsePatchQuote: null,
  loadingPatchQuote: false,
};

const UpdateQuote = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_QUOTE:
      state = {
        ...state,
        loadingUpdateQuote: true,
        errorUpdateQuote: null,
        responseUpdateQuote: true,
      };
      break;
    case UPDATE_QUOTE_SUCCESS:
      state = {
        ...state,
        errorUpdateQuote: null,
        loadingUpdateQuote: false,
        responseUpdateQuote: action.payload,
      };
      break;
    case UPDATE_QUOTE_ERROR:
      state = {
        ...state,
        errorUpdateQuote: action.payload,
        loadingUpdateQuote: false,
        responseUpdateQuote: null,
      };
      break;
    case UPDATE_QUOTE_CLEAR_DATA:
      state = {
        ...state,
        errorUpdateQuote: null,
        loadingUpdateQuote: null,
        responseUpdateQuote: false,
      };
      break;
    case PATCH_QUOTE:
      state = {
        ...state,
        loadingPatchQuote: true,
        errorPatchQuote: null,
        responsePatchQuote: true,
      };
      break;
    case PATCH_QUOTE_SUCCESS:
      state = {
        ...state,
        errorPatchQuote: null,
        loadingPatchQuote: false,
        responsePatchQuote: action.payload,
      };
      break;
    case PATCH_QUOTE_ERROR:
      state = {
        ...state,
        errorPatchQuote: action.payload,
        loadingPatchQuote: false,
        responsePatchQuote: null,
      };
      break;
    case PATCH_QUOTE_CLEAR_DATA:
      state = {
        ...state,
        errorPatchQuote: null,
        loadingPatchQuote: null,
        responsePatchQuote: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateQuote;